var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('div',{staticClass:"container is-fluid"},[_c('h2',{staticClass:"mb-1 half-top-section"},[_vm._v("Nuestros clientes /")]),_c('grid-photo',{attrs:{"list":_vm.list}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }